/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { View } from "react-native";
import { PropagateLoader } from "react-spinners";

import { skaleMainBlue } from "config/UpduoColors";

export default function LoadingView({
  color = skaleMainBlue,
  topSpacing = 50,
  bottomSpacing = 0,
  hideDots = false,
}) {
  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        marginTop: topSpacing,
        marginBottom: bottomSpacing,
      }}
    >
      <PropagateLoader
        color={hideDots ? "transparent" : color}
        loading={true}
      />
    </View>
  );
}
